import PropTypes from 'prop-types';

import { IconClose } from '../../Components/Common/Icons';
import { useLanguage } from '../../localization/useLanguage';
import dialogStyles from './index.module.scss';

/**
 * Title row of a pop-up, with the close icon at the end.
 *
 * @param {string} title Translated pop-up title.
 * @param {Function} onClose Called when the close icon is clicked.
 */
const DialogHead = ({ title, onClose }) => {
    const { t } = useLanguage();

    return (
        <div className={dialogStyles.head}>
            <h3>{title}</h3>
            <button type="button" className={dialogStyles.close} onClick={onClose} aria-label={t('common.CLOSE')}>
                <IconClose />
            </button>
        </div>
    );
};

DialogHead.propTypes = {
    title: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default DialogHead;
